import { OptionTemplate } from "shared/api/middleware-api-client";

export const getScaleRails = (
  width: number,
  selectedDoor: OptionTemplate | null,
) => {
  const leapNumber =
    width <= 999 ? 1 : 0.99 + ((width - 999) / (1750 - 999)) * (0.949 - 0.99);
  return selectedDoor?.code === "dubbeleschuifdeur2paneel" ? leapNumber : 1;
};

export const getKomHandleAdjustments = (
  width: number,
  selectedDoor: OptionTemplate | null,
) => {
  if (selectedDoor?.code === "schuifdeurpaneelpaneelschuifdeur") {
    const leapNumber =
      width <= 1150
        ? 0
        : 0.01 + ((width - 1150) / (1750 - 1150)) * (0.02 - 0.01);
    return { handleXAdjustment: leapNumber };
  }
  return { handleXAdjustment: 0 };
};
